import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = ['Noches buscando en Google "cómo calmar a un niño con TDAH" y encontrando consejos contradictorios que no funcionan en tu casa', 'Tu hijo explota en el supermercado, en el colegio, en la cena — y tú sin saber qué paso dar primero', 'El tutor te llama otra vez. Tu hijo no entrega los deberes, interrumpe, se pelea con los compañeros', 'Llevas meses con la misma rutina rota: gritos por la mañana, deberes que duran 3 horas, cenas que acaban en llanto', 'Sientes que tu relación con tu hijo se está deteriorando — y eso es lo que más duele', 'Los demás padres parecen tenerlo bajo control y tú sientes que te hundes', 'Los profesionales te dan diagnósticos pero nadie te dice exactamente qué hacer mañana por la mañana'];
export function PainPoints() {
  return <section className="bg-surface-white py-12 px-6" data-id="element-246">
      <div className="max-w-4xl mx-auto" data-id="element-247">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-248">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mb-3" data-id="element-249">
            ¿Cuántas noches más vas a terminar así?
          </h2>
          <p className="text-lg text-secondary mb-2" data-id="element-250">
            Amas a tu hijo con todo lo que tienes. Pero terminas cada día
            agotado/a, con la sensación de que todo lo que intentas no funciona.
          </p>
          <p className="text-lg text-secondary mb-2" data-id="element-251">
            No es que seas mal padre o mala madre.
          </p>
          <p className="text-xl font-bold text-primary" data-id="element-252">
            Es que nadie te dio un sistema.
          </p>
        </motion.div>

        <div className="space-y-3 mb-8" data-id="element-253">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="flex gap-4 items-start bg-white p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-254">
              <XCircle className="w-6 h-6 text-danger flex-shrink-0 mt-1" data-id="element-255" />
              <p className="text-primary text-lg leading-relaxed" data-id="element-256">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-navy text-white p-6 md:p-8 rounded-2xl shadow-xl" data-id="element-257">
          <h3 className="font-display text-2xl md:text-3xl font-bold text-gold" data-id="element-258">
            ¿Y si este fuera el último día que te sientes así de perdido/a?
          </h3>
        </motion.div>
      </div>
    </section>;
}